import { render, staticRenderFns } from "./SassVariablesTableEntry.vue?vue&type=template&id=1206df41&"
import script from "./SassVariablesTableEntry.vue?vue&type=script&lang=js&"
export * from "./SassVariablesTableEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports